import { initialFormValues, MaterialTypeFormattedData, materialTypeSchema as itemTypeSchema } from '../schemas';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { LoaiVatTu, LoaiVatTuInput } from '@/types/schemas';
import { useSearchFieldStates } from '../hooks';
import { BasicInfoTab } from './BasicInfoTab';
import { AccountTab } from './AccountTab';

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: LoaiVatTuInput) => void;
  formMode: 'add' | 'edit' | 'view';
  initialData?: LoaiVatTu;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

export const FormDialog = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}: FormDialogProps) => {
  const accountStates = useSearchFieldStates(initialData);

  const handleSubmit = async (data: MaterialTypeFormattedData) => {
    const updatedData = {
      ...data,
      tk_vt: accountStates.warehouseAccount?.uuid || null,
      tk_dt: accountStates.revenueAccount?.uuid || null,
      tk_gv: accountStates.costAccount?.uuid || null,
      tk_ck: accountStates.discountAccount?.uuid || null,
      tk_km: accountStates.promotionAccount?.uuid || null,
      tk_tl: accountStates.returnAccount?.uuid || null,
      tk_spdd: accountStates.wipAccount?.uuid || null,
      tk_cpnvl: accountStates.materialAccount?.uuid || null
    };

    onSubmit(updatedData);
  };

  const isCopyMode = formMode === 'add' && initialData !== undefined;

  const title = isCopyMode
    ? 'Sao chép loại vật tư'
    : formMode === 'add'
      ? 'Thêm loại vật tư'
      : formMode === 'edit'
        ? 'Sửa loại vật tư'
        : 'Xem loại vật tư';

  return (
    <DialogV2
      open={open}
      title={title}
      maxWidth='xl'
      disableBackdropClose={false}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={699} />}
    >
      <AritoFormV2
        hasAritoActionBar={false}
        mode={formMode}
        initialData={(initialData || initialFormValues) as MaterialTypeFormattedData}
        onSubmit={handleSubmit}
        schema={itemTypeSchema}
        headerFields={<BasicInfoTab formMode={formMode} />}
        className='w-[900px]'
        tabs={[
          {
            id: 'Account',
            label: 'Tài khoản',
            component: (
              <AccountTab
                formMode={formMode}
                warehouseAccount={accountStates.warehouseAccount}
                setWarehouseAccount={accountStates.setWarehouseAccount}
                revenueAccount={accountStates.revenueAccount}
                setRevenueAccount={accountStates.setRevenueAccount}
                costAccount={accountStates.costAccount}
                setCostAccount={accountStates.setCostAccount}
                discountAccount={accountStates.discountAccount}
                setDiscountAccount={accountStates.setDiscountAccount}
                promotionAccount={accountStates.promotionAccount}
                setPromotionAccount={accountStates.setPromotionAccount}
                returnAccount={accountStates.returnAccount}
                setReturnAccount={accountStates.setReturnAccount}
                wipAccount={accountStates.wipAccount}
                setWipAccount={accountStates.setWipAccount}
                materialAccount={accountStates.materialAccount}
                setMaterialAccount={accountStates.setMaterialAccount}
              />
            )
          }
        ]}
        bottomBar={
          <BottomActionBarV2
            mode={formMode}
            onAdd={onAddButtonClick}
            onEdit={onEditButtonClick}
            onDelete={onDeleteButtonClick}
            onCopy={onCopyButtonClick}
            onSubmit={() => {}}
            onClose={onClose}
          />
        }
      />
    </DialogV2>
  );
};

export default FormDialog;
